import form from './form';
import index from './index';
import { Router } from '@/legacy/Router';

Router.get('export/:any', form);
Router.get('export', index);
